<template>
  <div class="header-body" :class="{ scrolled: isScrolled }">
    <Sidebar v-if="isSidebarOpen" @close="toggleSidebar" />
    <div
      class="header"
      :class="{
        whiteTheme: !isScrolled && headerColor === 'white',
        blackTheme: isScrolled || headerColor === 'black',
      }"
    >
      <router-link to="/">
        <img
          class="logo white-logo"
          src="../../assets/white-logo.png"
          alt="white logo"
        />
        <img
          class="logo black-logo"
          src="../../assets/black-logo.png"
          alt="black logo"
        />
      </router-link>

      <div class="menu">
        <div
          class="menu-item for-brands"
          @mouseenter="openDropdown('brandsDropdown')"
          @mouseleave="closeDropdown('brandsDropdown')"
        >
          <router-link to="/" class="menuText">For Brands</router-link>
          <Dropdown
            v-if="dropdownOpen.brandsDropdown"
            :items="brandsDropdownItems"
            @navigate="handleDropdownNavigation"
          />
        </div>

        <div
          class="menu-item sustainability"
          @mouseenter="openDropdown('sustainabilityDropdown')"
          @mouseleave="closeDropdown('sustainabilityDropdown')"
        >
          <router-link to="/sustainability" class="menuText"
            >Sustainability</router-link
          >
          <Dropdown
            v-if="dropdownOpen.sustainabilityDropdown"
            :items="sustainabilityDropdownItems"
            @navigate="handleDropdownNavigation"
          />
        </div>

        <div
          class="menu-item company"
          @mouseenter="openDropdown('companyDropdown')"
          @mouseleave="closeDropdown('companyDropdown')"
        >
          <router-link to="/company" class="menuText">Company</router-link>
          <Dropdown
            v-if="dropdownOpen.companyDropdown"
            :items="companyDropdownItems"
            @navigate="handleDropdownNavigation"
          />
        </div>

        <a href="https://www.wecobi.com/">
          <div class="menuText">Platform</div>
        </a>
      </div>
      <a href="https://www.wecobi.com/login">
        <button class="getStarted">Get Started</button>
      </a>
      <div class="menu-icon-wrapper" @click="toggleSidebar">
        <img
          class="menu-icon white-menu-icon"
          src="../../assets/menu-icon.svg"
          alt="menu-icon"
        />
        <img
          class="menu-icon black-menu-icon"
          src="../../assets/menu-icon-black.svg"
          alt="menu-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import Dropdown from "./Dropdown.vue";
import Sidebar from "./Sidebar.vue";

export default {
  name: "Header",
  components: {
    Dropdown,
    Sidebar,
  },
  props: {
    headerColor: {
      type: String,
      default: "white",
    },
  },
  data() {
    return {
      dropdownOpen: {
        brandsDropdown: false,
        sustainabilityDropdown: false,
        companyDropdown: false,
      },
      isSidebarOpen: false,
      isScrolled: false, // Praćenje da li je korisnik skrolovao
      brandsDropdownItems: [
        {
          label: "Extending Lifecycles",
          link: "#extendingLifecycle",
        },
        {
          label: "AB testing",
          link: "#abtesting",
        },
        {
          label: "Optimized Discounts",
          link: "#optimizedDiscounts",
        },
        { label: "Overview", link: "#overview" },
      ],
      sustainabilityDropdownItems: [
        { label: "Our Mission", link: "/sustainability#mission" },
        {
          label: "Environmental Impact",
          link: "/sustainability#environmentalImpact",
        },
        { label: "Decoupled Growth", link: "/sustainability#decoupledGrowth" },
        { label: "Win-Win-Win Energy", link: "/sustainability#winEnergy" },
      ],
      companyDropdownItems: [
        { label: "About Us", link: "/company#aboutUs" },
        { label: "Partner Program", link: "/partnershipProgram" },
        { label: "Careers", link: "/careers" },
        { label: "Investor Relations", link: "/company#investorRelations" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll); // Dodavanje scroll listener-a
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll); // Uklanjanje listener-a
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 50; // Promjena isScrolled na osnovu skrol pozicije
    },
    openDropdown(dropdownName) {
      this.dropdownOpen[dropdownName] = true;
    },
    closeDropdown(dropdownName) {
      this.dropdownOpen[dropdownName] = false;
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    handleDropdownNavigation(link) {
      if (link.startsWith("#")) {
        if (this.$route.path === "/") {
          this.scrollToHash(link);
        } else {
          this.navigateAndScrollToHash("/", link);
        }
      } else if (link.includes("/sustainability")) {
        const hash = this.getValidHash(link, "/sustainability");
        if (this.$route.path === "/sustainability") {
          this.scrollToHash(hash);
        } else {
          this.navigateAndScrollToHash("/sustainability", hash);
        }
      } else if (link.includes("/company")) {
        const hash = this.getValidHash(link, "/company");
        if (this.$route.path === "/company") {
          this.scrollToHash(hash);
        } else {
          this.navigateAndScrollToHash("/company", hash);
        }
      } else {
        this.$router.push(link);
      }
      this.closeDropdown("brandsDropdown");
      this.closeDropdown("sustainabilityDropdown");
      this.closeDropdown("companyDropdown");
    },
    getValidHash(link, path) {
      const hash = link.replace(path, "");
      return hash.startsWith("#") ? hash : `#${hash}`;
    },
    scrollToHash(hash) {
      const validHash = hash.startsWith("#") ? hash : `#${hash}`;

      nextTick(() => {
        const element = document.querySelector(validHash);
        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${validHash} not found!`);
        }
      });
    },
    navigateAndScrollToHash(page, hash) {
      this.$router.push({ path: page }).then(() => {
        nextTick(() => {
          setTimeout(() => {
            this.scrollToHash(hash);
          }, 100);
        });
      });
    },
  },
};
</script>

<style scoped>
.header-body {
  position: relative;
}
.header-body.scrolled {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0px 38px 0px 49px;
  height: 71px;
  position: relative;
}

.logo {
  width: 170px;
}

.black-logo {
  display: none;
}

.blackTheme .white-logo {
  display: none;
}

.blackTheme .black-logo {
  display: block;
}

.whiteTheme .black-logo {
  display: none;
}

.whiteTheme .white-logo {
  display: block;
}

.menu {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 50px;
}

.menuText {
  font-size: 16px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.getStarted {
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  border: 2px solid;
  width: 153px;
  height: 50px;
  border-radius: 30px;
  cursor: pointer;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.whiteTheme .menuText,
.whiteTheme .getStarted {
  color: #ffffff;
  border-color: #ffffff;
}
.whiteTheme:hover,
.whiteTheme:hover {
  color: #ff6d0a;
}

.getStarted:hover {
  color: #ffffff;
  background-color: #000000;
  border-color: #000000;
}

.blackTheme .menuText,
.blackTheme .getStarted {
  color: #000000;
  border-color: #000000;
}
.blackTheme:hover .menuText:hover,
.blackTheme:hover {
  color: #ff6d0a;
}
.getStarted:hover {
  color: #ffffff;
  background-color: #000000;
  border-color: #000000;
}

.menu-icon-wrapper {
  display: none;
}

.white-menu-icon,
.black-menu-icon {
  width: 32px;
  height: 32px;
  display: none;
}

.whiteTheme .white-menu-icon {
  display: block;
}

.blackTheme .black-menu-icon {
  display: block;
}

.menu-item {
  position: relative;
}

.dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 100;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.menu-item.for-brands .dropdown {
  right: 0;
  left: auto;
}

.menu-item.sustainability .dropdown,
.menu-item.company .dropdown {
  left: 0;
  right: auto;
}
.sidebar {
  position: absolute;
  top: 0;
  right: 0;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media (max-width: 1024px) {
  .menu {
    gap: 30px;
  }
}
@media (max-width: 853px) {
  .menu,
  .getStarted {
    display: none;
  }
  .menu-icon-wrapper {
    display: block;
  }
  .header {
    padding: 0px 20px 0px 10px;
  }
}

@media (min-width: 853px) {
  .menu-wrapper,
  .menu-black-wrapper {
    display: none !important;
  }
}
</style>
